
		<div class="top-bar">
			<span *ngIf="user" i18n="@@welcome">Welcome: <b class="clickable-item" routerLink="/dashboard/users">{{user.firstName}}</b></span>
			<span *ngIf="!user || !user.firstName" i18n="@@welcome-unknow">Welcome: <b>unknow</b></span>
			<a style="margin-left: 10px;" (click)="logout()" i18n="@@logout">Logout</a>
		</div>
	